var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65 65",
    id: "Trophy",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5edbe5",
    d: "M29.1 31.4c-20-4.5-22-20.1-21.9-26.6 0-2.4 2-4.3 4.3-4.3 1.7 0 3 1.4 3 3 0 .6.5 1.1 1.1 1.1h4.7v1.9h-4.7c-1.7 0-3-1.4-3-3 0-.6-.5-1.1-1.1-1.1-1.3 0-2.4 1.1-2.4 2.4-.1 7.5 2.4 20.7 20.4 24.7l-.4 1.9zm6.8 0c20-4.5 22-20.1 21.9-26.6 0-2.4-2-4.3-4.3-4.3-1.7 0-3 1.4-3 3 0 .6-.5 1.1-1.1 1.1h-4.7v1.9h4.7c1.7 0 3-1.4 3-3 0-.6.5-1.1 1.1-1.1 1.3 0 2.4 1.1 2.4 2.4.1 7.5-2.4 20.7-20.4 24.7l.4 1.9z",
    className: "colore5a45e svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#74e8f1",
    d: "M37.8 30.5c7.7-5.2 9.3-6.8 9.3-29.9H17.8c0 23.1 1.7 24.7 9.3 29.9 3.1 2.1 3 9.6 3 9.6-1.7 0-1.9 2.5-1.9 2.5-3 0-4.2 2.7-4.2 2.7h16.8s-1.2-2.7-4.2-2.7c0 0-.2-2.5-1.9-2.5.1 0 0-7.4 3.1-9.6z",
    className: "colorf1b974 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f4",
    d: "m32.5 7.3 1.9 6h6.3l-5.1 3.6 2 6-5.1-3.7-5.1 3.7 2-6-5.1-3.6h6.3z",
    className: "colorf4f4f4 svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M42.4 45.3H22.6c-1 0-1.9.8-1.9 1.9v14h23.5v-14c.1-1-.8-1.9-1.8-1.9z",
    className: "color59595c svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e575a",
    d: "M50.3 64.5H14.7l4-3.3h27.6z",
    className: "color2e435a svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    d: "M24.5 48.9h16v8.8h-16z",
    className: "colord3d3d3 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.3552951ab441d1fbc22fe032690864ef.svg";
export { ForwardRef as ReactComponent };